import React, { Component } from 'react';
import { FormattedMessage, injectIntl } from '../../util/reactIntl';
import classNames from 'classnames';
import * as validators from '../../util/validators';
import {
  Form,
  PrimaryButton,
  FieldRadioButton,
  FieldTextInput,
  NamedLink,
  FieldPhoneNumberInput,
  FieldPhoneNumberInputWithDialCode,
  FieldPassword,
  SecondaryButton,
  InlineTextButton,
  Modal,
  FieldNumberInput,
  FieldRadioButtonGroup,
  FieldCustomSelect,
  FieldCheckbox,
  FieldAddress,
  FieldRecaptcha,
  CustomRadioButton,
  FieldDateInput,
  FieldWorkerJobCategory,
  FieldWorkerExperience,
  FieldReference,
  FieldPermitAndCertificate,
  FieldPerferredLang,
  FieldCalendlyMeet,
  FieldDisabledInput,
} from '../../components';

import css from './ConfirmSignupForm.module.css';
import { FormSpy } from 'react-final-form';
import { createResourceLocatorString } from '../../util/routes';
import routeConfiguration from '../../routeConfiguration';
import { apiBaseUrl } from '../../util/api';
import axios from '../../util/axiosHelper';
import { replaceNumberWithCharacter } from '../../util/richText';
import {
  USER_TYPE,
  age16PlusOptions,
  customIdsKeyName,
  drivingLicenseOptions,
  listingTypes,
  minimumAgeRequired,
  sosAdOptions,
  workerAllowedOptions,
} from '../../marketplace-custom-config';
import { isEmpty } from 'lodash';
import { getDefaultTimeZoneOnBrowser } from '../../util/dates';
import DateInput from '../../components/FieldDateInput/DateInput';
import moment from 'moment';
import { storedData } from '../../util/sessionStorageHelper';

const KEY_CODE_ENTER = 13;
const textfield = 'textfield';
const errorTextField = 'errorTextField';

const workagredOnTerms = 'yes';

class CustomerConfirmSignupComp extends Component {
  constructor(props) {
    super(props);
    this.recaptchRef = React.createRef();
    this.state = {
      showOtpModal: false,
      otpValidationInProgress: false,
      showNotAllowedModal: false,
      notAllowedHeadingId: 'SignupForm.notAllowedHeading',
      notAllowedBodyId: 'SignupForm.notAllowedBody',
    };
  }

  handleOnCancelBtnClick = () => {
    const { history } = this.props;
    history.replace(createResourceLocatorString('LandingPage', routeConfiguration()));
  };

  setShowOtpModal = status => {
    this.setState({ showOtpModal: status });
  };

  setShowNotAllowedModal = (
    status,
    headingId = 'SignupForm.notAllowedHeading',
    bodyId = 'SignupForm.notAllowedBody'
  ) => {
    this.setState({
      showNotAllowedModal: status,
      notAllowedHeadingId: headingId,
      notAllowedBodyId: bodyId,
    });
  };

  checkAndHideOtpModal = () => {
    if (this.state.otpValidationInProgress) return;
    this.setShowOtpModal(false);
  };

  requestForOtp = async () => {
    this.setShowOtpModal(true);
    try {
      const { formApi } = this.props;
      const { values } = formApi.getState();
      const {
        phoneNumber: { number, dialCode },
      } = values;
      const mobileNumber = `${dialCode}${number}`;
      const url = `${apiBaseUrl()}/api/user/generate/phoneotp/mobile`;
      await axios.post(url, { mobile: mobileNumber });
    } catch (err) {
      console.error(err);
    }
  };

  formBatchUpdate = (entries = []) => {
    const { formApi } = this.props;
    formApi.batch(() => {
      for (let entry of entries) {
        formApi.change(entry[0], entry[1]);
      }
    });
  };

  verifyOtp = async () => {
    if (this.state.otpValidationInProgress) return;
    this.setState({ otpValidationInProgress: true });
    const { formApi, onSubmit } = this.props;
    const { values } = formApi.getState();
    const {
      phoneNumber: { number, dialCode },
      otp,
    } = values;
    formApi.change('refOtp', '');
    try {
      const mobileNumber = `${dialCode}${number}`;
      const url = `${apiBaseUrl()}/api/user/validate/phoneotp/mobile`;
      await axios.post(url, { mobile: mobileNumber, otp });
      formApi.change('isPhoneNumberVerified', true);
      this.setState({ otpValidationInProgress: false, showOtpModal: false });
    } catch (err) {
      const entries = [['refOtp', '-1']];
      this.formBatchUpdate(entries);
      formApi.focus('otp');
      setTimeout(() => formApi.blur('otp'), 100);
      this.setState({ otpValidationInProgress: false });
    }
  };

  handleRecaptchStatusChange = value => {
    const { recaptchaStatus } = value;
    const { formApi } = this.props;
    formApi.change('recaptchaStatus', { ...recaptchaStatus });
  };

  handleSubmit = async event => {
    event.preventDefault();
    event.stopPropagation();
    const { formApi, error, onSubmit } = this.props;
    if (!isEmpty(error)) return;
    const { values } = formApi.getState();
    const {
      age16Plus,
      workerAllowed,
      // birthdate,
      preferredLang,
      recaptchaStatus = {},
      phoneNumber,
      drivingLicense,
      lastName,
      firstName,
      workerAgrement,
      isPhoneNumberVerified = false,
    } = values;
    const { hasRecaptchaValidated = false } = recaptchaStatus;
    if (!hasRecaptchaValidated) return;
    const hasValidValue =
      workerAllowed === workerAllowedOptions.yes.value && age16Plus === age16PlusOptions.yes.value;
    // birthdate &&
    // birthdate.date &&
    // birthdate.date instanceof Date;
    if (!hasValidValue) return;
    if (isPhoneNumberVerified) {
      const { number: num, iso2, iso3, dialCode: dcode } = phoneNumber;
      const publicData = {
        workerAllowed,
        drivingLicense,
        age16Plus,
        workerAgrement: workerAgrement[0],
        isProvider: false,
        preferredLang: preferredLang,
      };
      const protectedData = {
        // birthdate: birthdate.date.toISOString(),
        phoneNumber: { number: num, iso2, iso3, dialCode: dcode },
        isPhoneNumberVerified: true,
        isSocialSignup: true,
        timeZone: getDefaultTimeZoneOnBrowser(),
      };
      const updatedValues = { lastName, firstName, publicData, protectedData };
      await onSubmit(updatedValues);
    } else {
      if (this.state.showOtpModal) {
        this.verifyOtp();
      } else {
        this.requestForOtp();
      }
    }
  };

  handleWorkerAllowedChange = value => {
    const { formApi } = this.props;
    formApi.change('workerAllowed', value);
    if (value === workerAllowedOptions.no.value) {
      this.setShowNotAllowedModal(true);
    }
  };
  handleAge16PlusChange = value => {
    const { formApi } = this.props;
    formApi.change('age16Plus', value);
    if (value === workerAllowedOptions.no.value) {
      this.setShowNotAllowedModal(
        true,
        'SignupForm.not16YearOldHeading',
        'SignupForm.not16YearOldBody'
      );
    }
  };

  handleDrivingLicenseChange = value => {
    const { formApi } = this.props;
    formApi.change('drivingLicense', value);
  };

  render() {
    const {
      values,
      intl,
      inProgress,
      invalid,
      formId,
      rootClassName,
      className,
      onManageDisableScrolling,
      userNativeLang,
      signupErrorMessage,
      isEmailTakenError,
      authInfo,
    } = this.props;

    const { userType, firstName, lastName, email } = authInfo || {};
    const sessionUserType = storedData(USER_TYPE);
    const isValidUserType =
      !!userType &&
      !!sessionUserType &&
      sessionUserType === userType &&
      [customIdsKeyName.worker, customIdsKeyName.guest].includes(sessionUserType);

    if (!isValidUserType) {
      return <NamedRedirect name="SignupAsWorkerPage" />;
    }

    const firstNameId = formId ? `${formId}.firstName` : 'firstName';
    const lastNameId = formId ? `${formId}.lastName` : 'lastName';
    const emailId = formId ? `${formId}.email` : 'email';
    const phoneNumberId = formId ? `${formId}.phoneNumber` : 'phoneNumber';
    const recaptchaId = formId ? `${formId}.recaptchaStatus` : 'recaptchaStatus';
    const workerAllowedOptionsId = formId
      ? `${formId}.workerAllowedOptions`
      : 'workerAllowedOptions';

    const drivingLicenseOptionsId = formId
      ? `${formId}.drivingLicenseOptions`
      : 'drivingLicenseOptions';

    const age16PlusOptionsId = formId ? `${formId}.age16PlusOptions` : 'age16PlusOptions';
    const birthdateId = formId ? `${formId}.birthdate` : 'birthdate';
    const workerAgreementId = formId ? `${formId}.workerAgreement` : 'workerAgreement';
    const preferredLangId = formId ? `${formId}.preferredLang` : 'preferredLang';
    const {
      phoneNumber,
      refOtp = '',
      recaptchaStatus = {},
      workerAllowed,
      drivingLicense,
      age16Plus,
      workerAgrement = [],
    } = values;

    const { dialCode, number = '' } = phoneNumber;
    const phoneNumberWithDialCode = `${dialCode} ${replaceNumberWithCharacter(number, 'X')}`;
    const { hasRecaptchaValidated = false } = recaptchaStatus;
    const classes = classNames(rootClassName || css.root, className);
    const submitInProgress = inProgress;

    const isFormOtherFieldInvalid =
      invalid ||
      workerAllowed === workerAllowedOptions.no.value ||
      age16Plus === age16PlusOptions.no.value ||
      (workerAgrement && workerAgrement[0] !== workagredOnTerms);

    const reacaptchaInitialValueMaybe =
      recaptchaStatus &&
      typeof recaptchaStatus.hasRecaptchaValidated !== 'undefined' &&
      typeof recaptchaStatus.isRecaptchaInvalid !== 'undefined'
        ? { initialValue: recaptchaStatus }
        : {};

    const submitDisabled = isFormOtherFieldInvalid || submitInProgress || !hasRecaptchaValidated;

    // email
    const emailLabel = intl.formatMessage({
      id: 'SignupForm.emailLabel',
    });

    // firstName
    const firstNameLabel = intl.formatMessage({
      id: 'SignupForm.firstNameLabel',
    });
    const firstNamePlaceholder = intl.formatMessage({
      id: 'SignupForm.firstNamePlaceholder',
    });
    const firstNameRequiredMessage = intl.formatMessage({
      id: 'SignupForm.firstNameRequired',
    });
    const firstNameRequired = validators.required(firstNameRequiredMessage);

    // lastName
    const lastNameLabel = intl.formatMessage({
      id: 'SignupForm.lastNameLabel',
    });
    const lastNamePlaceholder = intl.formatMessage({
      id: 'SignupForm.lastNamePlaceholder',
    });
    const lastNameRequiredMessage = intl.formatMessage({
      id: 'SignupForm.lastNameRequired',
    });
    const lastNameRequired = validators.required(lastNameRequiredMessage);

    // phone number
    const phoneNumberLabel = intl.formatMessage({
      id: 'SignupForm.phoneNumbeLabel',
    });
    const phoneNumberPlaceholder = intl.formatMessage({
      id: 'SignupForm.phoneNumbePlaceholder',
    });
    const phoneNumberRequiredMessage = intl.formatMessage({
      id: 'SignupForm.phoneNumbeRequired',
    });
    const phoneNumberRequired = validators.phoneNumberRequired(phoneNumberRequiredMessage);

    //birthdate select
    const birthdateLabel = intl.formatMessage({
      id: 'SignupForm.birthDateSelectLabel',
    });
    const birthdatePlaceholder = intl.formatMessage({
      id: 'SignupForm.birthDateSelectPlaceholder',
    });
    const birthdateRequiredMessage = intl.formatMessage(
      {
        id: 'SignupForm.birthDateSelectRequired',
      },
      { minValue: minimumAgeRequired }
    );
    const birthdateValidator = validators.composeValidators(
      validators.required(birthdateRequiredMessage),
      validators.isDateAboveMinValue(birthdateRequiredMessage, minimumAgeRequired)
    );

    //otp
    const otpPlaceholder = intl.formatMessage({
      id: 'SignupForm.otpPlaceholder',
    });
    const otpRequiredMessage = intl.formatMessage({
      id: 'SignupForm.otpRequired',
    });
    const otpInvalidMessage = intl.formatMessage({
      id: 'SignupForm.invalidOtp',
    });

    const otpValidator = validators.composeValidators(
      validators.required(otpRequiredMessage),
      validators.isValidOtp(otpInvalidMessage, refOtp)
    );

    // worker aggrement
    const workerAgrementLabel = intl.formatMessage({
      id: 'SignupForm.workerAgrementLabel',
    });

    const loginLink = (
      <NamedLink name="LoginPage" className={css.loginLink}>
        <FormattedMessage id="AuthenticationPage.loginLinkText" />
      </NamedLink>
    );

    const termsLink = (
      <NamedLink name="TermsOfServicePage" className={css.termsLink}>
        <FormattedMessage id="SignupForm.termsAndConditionsLinkText" />
      </NamedLink>
    );

    const policyLink = (
      <NamedLink name="PrivacyPolicyPage" className={css.termsLink}>
        <FormattedMessage id="SignupForm.policyLinkText" />
      </NamedLink>
    );

    const contactUsLink = (
      <NamedLink name="TermsOfServicePage" className={css.termsLink}>
        <FormattedMessage id="SignupForm.contactusLinkText" />
      </NamedLink>
    );

    return (
      <Form className={classes} onSubmit={this.handleSubmit}>
        <React.Fragment>
          <div className={css.customerformWrap}>
            <div className={css.row}>
              <FieldTextInput
                className={textfield}
                errorClassName={errorTextField}
                type="text"
                id={firstNameId}
                name="firstName"
                autoComplete="given-name"
                label={firstNameLabel}
                placeholder={firstNamePlaceholder}
                validate={firstNameRequired}
                initialValue={firstName}
              />
              <FieldTextInput
                className={textfield}
                errorClassName={errorTextField}
                type="text"
                id={lastNameId}
                name="lastName"
                autoComplete="family-name"
                label={lastNameLabel}
                placeholder={lastNamePlaceholder}
                validate={lastNameRequired}
                initialValue={lastName}
              />
            </div>
            <div className={css.row}>
              <FieldDisabledInput value={email} id={emailId} name="email" label={emailLabel} />

              <FieldPhoneNumberInputWithDialCode
                name="phoneNumber"
                id={phoneNumberId}
                label={phoneNumberLabel}
                placeholder={phoneNumberPlaceholder}
                validate={phoneNumberRequired}
                className={textfield}
                errorClassName={errorTextField}
              />
            </div>
          </div>
          <div className={css.supportingDocWrapper}>
            {/*<h3 className={css.header}>
                {intl.formatMessage({ id: 'SignupForm.supportingDocHeader' })}
        </h3>*/}
            <div className={css.allowedOption}>
              <div className={css.text}>
                {intl.formatMessage({ id: 'SignupForm.allowedWorkerLabel' })}
              </div>
              <CustomRadioButton
                name="workerAllowed"
                onChange={this.handleWorkerAllowedChange}
                radioValues={Object.values(workerAllowedOptions)}
                id={workerAllowedOptionsId}
                withForm={false}
                formClassName={css.option}
                values={values}
                radioSelectedInputClassName={classNames({
                  [css.notAllowedOption]: workerAllowed === workerAllowedOptions.no.value,
                })}
              />
            </div>
            <div className={classNames(css.allowedOption, css.columnOption)}>
              <div className={css.optionContent}>
                <div className={css.text}>
                  {intl.formatMessage({ id: 'SignupForm.birthDateLabel' })}
                </div>
                <CustomRadioButton
                  name="age16Plus"
                  onChange={this.handleAge16PlusChange}
                  radioValues={Object.values(age16PlusOptions)}
                  id={age16PlusOptionsId}
                  withForm={false}
                  formClassName={css.option}
                  values={values}
                  radioSelectedInputClassName={classNames({
                    [css.notAllowedOption]: age16Plus === age16PlusOptions.no.value,
                  })}
                />
              </div>
              {/* {age16Plus === age16PlusOptions.yes.value && (
                <FieldDateInput
                  name="birthdate"
                  id={birthdateId}
                  placeholderText={birthdatePlaceholder}
                  label={birthdateLabel}
                  validate={birthdateValidator}
                  className={textfield}
                  errorClassName={errorTextField}
                  isOutsideRange={date => moment().diff(date, 'days') <= 0}
                  displayFormat="DD/MM/YYYY"
                  userNativeLang={userNativeLang}
                />
              )} */}
            </div>
            <div className={css.allowedOption}>
              <div className={css.text}>
                {intl.formatMessage({ id: 'SignupForm.drivingLicenseLabel' })}
              </div>
              <CustomRadioButton
                name="drivingLicense"
                onChange={this.handleDrivingLicenseChange}
                radioValues={Object.values(drivingLicenseOptions)}
                id={drivingLicenseOptionsId}
                withForm={false}
                formClassName={css.option}
                values={values}
                radioSelectedInputClassName={classNames({
                  [css.notAllowedOption]: drivingLicense === drivingLicenseOptions.no.value,
                })}
              />
            </div>
          </div>
          <div>
            <FieldPerferredLang
              id={preferredLangId}
              userNativeLang={userNativeLang}
              name="preferredLang"
              className={textfield}
              errorClassName={errorTextField}
            />
          </div>
          <div className={css.workerAgrementWrap}>
            <FieldCheckbox
              name="workerAgrement"
              id={workerAgreementId}
              label={workerAgrementLabel}
              value={workagredOnTerms}
              className={textfield}
            />
          </div>

          <FieldRecaptcha
            id={recaptchaId}
            name="recaptchaStatus"
            enableRecaptcha={!isFormOtherFieldInvalid}
            onChange={this.handleRecaptchStatusChange}
            {...reacaptchaInitialValueMaybe}
          />
        </React.Fragment>

        <div className={css.bottomWrapper}>
          {!isEmailTakenError && signupErrorMessage}
          <div className={css.btnWrapper}>
            <PrimaryButton
              type="submit"
              inProgress={submitInProgress && !this.state.showOtpModal}
              disabled={submitDisabled || this.state.showOtpModal}
              className={css.submitBtn}
            >
              <FormattedMessage id="SignupForm.signUp" />
            </PrimaryButton>
          </div>
          {/*className={css.bottomWrapperText}*/}

          <p className={css.helperTextWrapper}>
            <span className={css.termsText}>
              <FormattedMessage
                id="SignupForm.termsAndConditionsAcceptText"
                values={{ termsLink, policyLink }}
              />
            </span>
            <span>
              <FormattedMessage id="SignupForm.contactusText" values={{ contactUsLink }} />
            </span>
          </p>
        </div>

        <Modal
          id="CustomerConfirmSignup.verifyotp"
          isOpen={this.state.showOtpModal}
          onClose={this.checkAndHideOtpModal}
          onManageDisableScrolling={onManageDisableScrolling}
          showCloseButtonMessage={false}
        >
          {this.state.showOtpModal && (
            <div className={css.otpContentWrapper}>
              <div className={css.contentHeading}>
                <h3 className={css.heading}>
                  {intl.formatMessage({ id: 'SignupForm.otpHeading' })}
                </h3>
                <p className={css.subHeading}>
                  {intl.formatMessage({ id: 'SignupForm.otpSubheading' })}
                </p>
                <div>
                  <div className={css.changeNumberWrapper}>
                    <span className={css.changeNumberText}>{phoneNumberWithDialCode}</span>
                    <InlineTextButton
                      type="button"
                      className={css.changeNumberBtn}
                      onClick={this.checkAndHideOtpModal}
                    >
                      {intl.formatMessage({ id: 'SignupForm.changeNumberText' })}
                    </InlineTextButton>
                  </div>
                  <FieldNumberInput
                    id="otp"
                    name="otp"
                    placeholder={otpPlaceholder}
                    validate={otpValidator}
                    className={textfield}
                    errorClassName={errorTextField}
                    key={refOtp}
                  />
                  <div className={css.noOtpWrapper}>
                    <span className={css.noOtpText}>
                      {intl.formatMessage({ id: 'SignupForm.noOtpText' })}
                    </span>
                    <InlineTextButton
                      type="button"
                      className={css.noOtpBtn}
                      onClick={this.requestForOtp}
                    >
                      {intl.formatMessage({ id: 'SignupForm.resendOtpText' })}
                    </InlineTextButton>
                  </div>
                </div>
                <SecondaryButton
                  type="button"
                  className={css.otpCheckBtn}
                  inProgress={this.state.otpValidationInProgress}
                  onClick={this.verifyOtp}
                >
                  {intl.formatMessage({ id: 'SignupForm.otpHeading' })}
                </SecondaryButton>
              </div>
            </div>
          )}
        </Modal>
        <Modal
          id="CustomerConfirmSignup.notallowed"
          isOpen={this.state.showNotAllowedModal}
          onClose={this.setShowNotAllowedModal.bind(this, false)}
          onManageDisableScrolling={onManageDisableScrolling}
          showCloseButtonMessage={false}
        >
          {this.state.showNotAllowedModal && (
            <div className={css.notAllowedWrapper}>
              <h3 className={css.header}>
                {intl.formatMessage({ id: this.state.notAllowedHeadingId })}
              </h3>
              <p className={css.body}>{intl.formatMessage({ id: this.state.notAllowedBodyId })}</p>
              <SecondaryButton
                type="button"
                className={css.btn}
                onClick={this.setShowNotAllowedModal.bind(this, false)}
              >
                {intl.formatMessage({ id: 'SignupForm.notAllowedBtnText' })}
              </SecondaryButton>
            </div>
          )}
        </Modal>
      </Form>
    );
  }
}
const CustomerConfirmSignup = injectIntl(CustomerConfirmSignupComp);

export default CustomerConfirmSignup;
